var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbovenormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#ABC3DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2535 8.59696C6.4846 8.82806 6.85863 8.82764 7.08931 8.59696L9.42373 6.26254L9.42373 13.1939C9.42373 13.5207 9.68785 13.7848 10.0146 13.7848C10.3415 13.7848 10.6056 13.5207 10.6056 13.1939L10.6056 6.26254L12.94 8.59696C13.1711 8.82806 13.5451 8.82764 13.7758 8.59696C14.0065 8.36628 14.0069 7.99225 13.7758 7.76115L10.4326 4.41791C10.2015 4.18681 9.82743 4.18723 9.59674 4.41791L6.2535 7.76115C6.02282 7.99183 6.0224 8.36586 6.2535 8.59696Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbovenormal);
export default __webpack_public_path__ + "static/media/above normal.6a5badc8779dfca0f25aa073daab8391.svg";
export { ForwardRef as ReactComponent };